import { environment } from '@env/environment';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ExamsByCode } from '../templates/exams-config/ExamsByCode.class';
import { DatabaseService } from '@app/database/database.service';
import { Observable } from 'rxjs';
import { EditExamenTemplateContainerService } from './edit-examen-template-container.service';
import moment from 'moment';

@Component({
  selector: 'app-edit-examen-template-container',
  templateUrl: './edit-examen-template-container.component.html',
  styleUrls: ['./edit-examen-template-container.component.scss']
})
export class EditExamenTemplateContainerComponent implements OnInit {
  examsByCode = new ExamsByCode().data;
  examData: any;
  examenDataFromSIngleService
  selectedTemplate: any;

  constructor(
    private databaseService: DatabaseService,
    private editExamenTemplateService: EditExamenTemplateContainerService,
    private actRoute: ActivatedRoute
  ) {
    this.editExamenTemplateService.examData.subscribe(
      (examData) => (this.examData = examData)
    );
  }

  async ngOnInit(): Promise<void> {

    if (!this.examData.isExamenPorEnviar) {
      await this.getSingleExamenData()
        .subscribe(
          async (results) => {
            // console.log('GET SINGLE DATA Data del item particular cargado', results.body);
            this.buildObjectForTemplateFromService(results.response).then( async () => {
              await this.setTemplateToExamen();
            } )
          },
          async (error) => {
            console.log('ERROR ON GET SINGLE DATA al filtrar examenes cargados: ', error);
            // this.getExamenesCargadosOffline();
          });
    } else {
      this.buildObjectForTemplateFromPorEnviar().then( async () => {
        await this.setTemplateToExamen();
      } )
    }
  }

  /**
   * refactor para unir template y examen sin perder la vista actual
   */
  private async setTemplateToExamen(): Promise<void> {
    const examCode = this.actRoute.snapshot.params.codigoTipoExamen;

    const examenTable = "periodicos"; // await this.actRoute.snapshot.params.categoriaExamen;
    // this.examData = await this.databaseService.getSingleExamenItem(examenTable, parseInt(examId, 10));

    this.selectedTemplate = await this.examsByCode[examCode];
  }

  private getSingleExamenData(): Observable<any> {
    return this.editExamenTemplateService.getSingleExamenData(this.examData.id, this.examData.tipoEstudio.tipoEstudioCod);

  }

  async buildObjectForTemplateFromService(data: any): Promise<void> {
    this.examData.fechaRealizacion = this._standarizeDateFechaRealizacion(this.examData);
    const finalRemapedData = { modoVista: 'edit', ...this.examData, ...data };
    this.examData = finalRemapedData;

    // console.log('Final data build fron cargados mas service', finalRemapedData);
  }

  async buildObjectForTemplateFromPorEnviar(): Promise<void> {
    this.examData.examenData.fechaRealizacion = this._standarizeDateFechaRealizacion(this.examData.examenDataToSend);
    this.examData.examenDataToSend.fechaRealizacion = this._standarizeDateFechaRealizacion(this.examData.examenDataToSend);
    this.examData.examenData.attachments = this.examData.examenDataToSend.adjuntos;

    const finalRemapedTrabajadorData = {
      ...this.examData.examenData.trabajador,
      ...this.examData.examenDataToSend.trabajador
    };

    const finalRemapedData = {
      ...this.examData.examenData,
      ...this.examData.examenDataToSend,
      'trabajador': finalRemapedTrabajadorData,
      "tipoEstudio": this.examData.examenData.tipoEstudio,
      "abierto": true,
      "modoVista": "edit",
      "aunPorEnviar": true
    };

    this.examData = finalRemapedData;
    // console.log('Final data build fron Examenes Por Enviar', finalRemapedData);
  }

  // HELPERS
  /**
   *
   * @param data
   * @returns {Date}
   */
  _standarizeDateFechaRealizacion(data: any) {
    let splitedDate = data.fechaRealizacion.split('-');
    return new Date(parseInt(splitedDate[0]), parseInt(splitedDate[1]) -1, parseInt(splitedDate[2]));
  }
}

